export const readFromLocalStorage = (key: string, initialValue: any) => {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : initialValue;
};
